import { OracleSource } from '@velocity-exchange/sdk';
import { useMemo } from 'react';
import { ORACLE_SOURCES_ENABLED_FOR_SIGNED_MSG_ORDERS } from 'src/constants/signedOrderMsgs';
import { ENUM_UTILS } from '@velocity-exchange/common';
import useDevSwitchIsOn from 'src/hooks/useDevSwitchIsOn';

// Markets who are not on whitelisted oracle sources, but still allowed to use SWIFT
const WHITELISTED_MARKET_INDEXES = [75];

// Markets who are disabled for signed msg orders
const DISABLED_MARKET_INDEXES =
	process.env.NEXT_PUBLIC_SIGNED_MSG_ORDER_DISABLED_MARKET_INDEXES?.split(',')
		.map(Number)
		.filter((n) => !isNaN(n)) ?? [];

export function useMarketEnabledForSignedMsgOrders(
	marketOracle: OracleSource | undefined,
	marketIndex: number
) {
	const devSwitchIsOn = useDevSwitchIsOn();
	const isEnabled = useMemo(
		() =>
			ORACLE_SOURCES_ENABLED_FOR_SIGNED_MSG_ORDERS.some((o) =>
				ENUM_UTILS.match(o, marketOracle)
			) || WHITELISTED_MARKET_INDEXES.includes(marketIndex),
		[marketOracle, marketIndex]
	);

	return useMemo(
		() =>
			devSwitchIsOn ||
			(isEnabled && !DISABLED_MARKET_INDEXES.includes(marketIndex)),
		[devSwitchIsOn, isEnabled, marketIndex]
	);
}
